import React from 'react'
import EditCompany from '../../components/EditCompany'
import { useParams } from 'react-router-dom'
import { getCompanyById, updateFundingCompany } from '../../api/fundingApi'

const EditFundingCompany = () => {
  const { id } = useParams()
  return (
    <>
      <EditCompany
        id={id}
        apiConfig={{
          updateFn: updateFundingCompany,
          getFn: getCompanyById,
        }}
      />
    </>
  )
}

export default EditFundingCompany
